// Dostęp do manifestu bloga wygenerowanego przez scripts/build-blog.js.
// Wszystkie ścieżki, hreflangi, paginacja i powiązania są policzone przy buildzie —
// tutaj tylko wyszukiwanie, żeby render (a więc i prerender) był czysto
// deterministyczny.
import manifest from "./generated/manifest.json";

export const SITE = manifest.site;
export const PUBLISHER = manifest.publisher;
export const LANGS = manifest.langs;
export const BLOG_LANGS = Object.keys(manifest.langs);

export const langConfig = (lang) => manifest.langs[lang];

export const postsFor = (lang) => manifest.posts.filter((p) => p.lang === lang);

export const getPost = (lang, slug) =>
  manifest.posts.find((p) => p.lang === lang && p.slug === slug) || null;

export const getPostsBySlugs = (lang, slugs) =>
  slugs.map((s) => getPost(lang, s)).filter(Boolean);

export const getPage = (lang, number) =>
  (manifest.pages[lang] || []).find((p) => p.number === Number(number)) || null;

export const getPages = (lang) => manifest.pages[lang] || [];

export const getTag = (lang, tag) =>
  (manifest.tags[lang] || []).find((t) => t.tag === tag) || null;

export const getTags = (lang) => manifest.tags[lang] || [];

export const getAuthor = (lang, slug) => (manifest.authors[lang] || {})[slug] || null;

export const postsByAuthor = (lang, slug) =>
  postsFor(lang).filter((p) => p.author === slug);

export const absolute = (path) => `${SITE}${path}`;

export default manifest;
